// eslint-disable-next-line no-unused-vars
import request from '@/service/http'
export function add (data) {
    return request({
      url: '/api/student/save',
      method: 'post',
      data,
    })
  }
  export function searchList (data) {
    return request({
      url: '/api/student/searchList',
      method: 'post',
      data,
    })
  }
  export function detail (data) {
    return request({
      url: '/api/student/detail',
      method: 'post',
      data,
    })
  }
  export function updata (data) {
    return request({
      url: '/api/student/update',
      method: 'post',
      data,
    })
  }
  /**
 * 编辑版本初始化
 */
export function deleteed (data) {
  return request({
    url: '/api/student/delete',
    method: 'post',
    data,
  })
}
/**
 * 编辑版本详情
 */
export function versionDetail (data) {
  return request({
    url: '/api/student/detail',
    method: 'post',
    data,
  })
}

/**
 * 重置密码
 */
export function reset (data) {
  return request({
    url: '/api/student/reset',
    method: 'post',
    data,
  })
}

/**
 * 结业
 */
export function studyComplete (data) {
  return request({
    url: '/api/student/studyComplete',
    method: 'post',
    data,
  })
}

/**
 * 一键结业
 */
export function allStudyComplete (data) {
  return request({
    url: '/api/student/allStudyComplete',
    method: 'post',
    data,
  })
}

/**
 * 取消结业
 */
export function cancelStudyComplete (data) {
  return request({
    url: '/api/student/cancelStudyComplete',
    method: 'post',
    data,
  })
}

/**
 * 解锁
 */
export function resetLockSingleUser (userId) {
  return request({
    url: '/api/student/resetLockSingleUser',
    method: 'post',
    params: {userId},
  })
}

export function classStudentSelectAddSearchList (data) {
  return request({
    url: '/api/student/classStudentSelectAddSearchList',
    method: 'post',
    data,
  })
}

export function classStudentSelectAddSave (data) {
  return request({
    url: '/api/student/classStudentSelectAddSave',
    method: 'post',
    data,
  })
}
